/* ama-hero-video.js
   Inserisce un video di sfondo (autoplay, muted, loop) nella sezione
   image-with-text-overlay con heading "Questo è il benessere.",
   nascondendo l'immagine. Overlay e testo restano sopra. */
(function () {
  'use strict';
  var SRC = 'https://cdn.shopify.com/videos/c/vp/c9fcc0a6385c4b349394be8e827e0ba7/c9fcc0a6385c4b349394be8e827e0ba7.HD-720p-3.0Mbps-88429087.mp4';
  function init() {
    var medias = document.querySelectorAll('.banner__media');
    for (var i = 0; i < medias.length; i++) {
      var media = medias[i];
      if (media.__amaVideo) continue;
      var sec = media.closest('.shopify-section') || media.closest('.section');
      if (!sec || !/Questo\s+è\s+il\s+benessere/i.test(sec.textContent || '')) continue;
      media.__amaVideo = true;
      var pic = media.querySelector('picture, img');
      if (pic) pic.style.display = 'none';
      var v = document.createElement('video');
      v.src = SRC;
      v.autoplay = true; v.loop = true; v.muted = true; v.defaultMuted = true;
      v.setAttribute('muted', ''); v.setAttribute('autoplay', '');
      v.setAttribute('loop', ''); v.setAttribute('playsinline', '');
      v.playsInline = true;
      v.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;object-fit:cover;z-index:0;';
      media.insertBefore(v, media.firstChild);
      var p = v.play(); if (p && p.catch) p.catch(function () {});
    }
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  window.addEventListener('load', init);
  document.addEventListener('shopify:section:load', init);
})();
